// statusType (integer): 订单状态:
export const ORDER_STATUS_TYPE_ENUM = {
  WAIT_PAY: {
    value: 10,
    desc: '待支付'
  },
  PAID: {
    value: 20,
    desc: '已支付'
  },
  COMPLETE: {
    value: 30,
    desc: '已完成'
  },
  CLOSE: {
    value: 90,
    desc: '交易关闭'
  }
};

export default {
  ORDER_STATUS_TYPE_ENUM
};
